module.exports = __webpack_public_path__ + "static/media/shoe_01.1ec725a8.jpg";